import {
  IsUUID,
  IsString,
  IsOptional,
  IsEnum,
  ValidateNested,
  IsArray,
  IsDateString,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  SalesResponseInterface,
  SaleAttachmentsResponseInterface,
  SalesAttachmentsStatus,
  SalesStatus,
  SalesQuarters,
} from '../../interface/sales/sales-response.interface';

import { MiniUsersDto } from '../users/users.dto';
import { MonitoringsDto } from '../monitorings/monitorings.dto';
import { AttachmentsDto } from '../attachments/attachments.dto';
import { CategoryTypes } from '../../utils/enums.utils';

export class SaleAttachmentsDto implements SaleAttachmentsResponseInterface {

  @IsUUID()
  sales_id!: string;

  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment!: AttachmentsDto;

  @IsEnum(SalesAttachmentsStatus)
  status!: SalesAttachmentsStatus;
}

export class SalesDto implements SalesResponseInterface {

  @IsUUID()
  id!: string;

  @IsEnum(SalesQuarters)
  quarter!: SalesQuarters;

  @IsEnum(SalesStatus)
  status!: SalesStatus;

  @IsEnum(CategoryTypes)
  category!: CategoryTypes;

  @IsOptional()
  @IsString()
  po_number!: string | null;

  @IsOptional()
  @IsString()
  invoice_number!: string | null;

  @IsOptional()
  @IsString()
  dr_number!: string | null;

  @IsOptional()
  @IsString()
  sales_remark!: string | null;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  // Created / Updated By
  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  // Nested Monitoring (Required)
  @ValidateNested()
  @Type(() => MonitoringsDto)
  monitoring!: MonitoringsDto;

  // Attachments array
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SaleAttachmentsDto)
  attachments!: SaleAttachmentsDto[] | null;
}